// eslint-disable-next-line import/prefer-default-export
export const DEFAULT_NOTIFICATION_DURATION = 5000;
